module.exports = __webpack_public_path__ + "media/images/common/menu_btn4-c7033d986cc1ab35f35df7612c9af032.png";